import urlParameter from '@hc-frontend/shared-assets/src/js/utils/url/urlParameter'
import appStateUpdated from 'utils/appStateUpdated'
import { IS_AGENT } from 'core/constants/environment'
import getTemplate from '../utils/getTemplate'
import renderError from '../utils/renderError'
import applyRules from './applyRules'
import store from 'utils/store/withMiddleware'
import updateDOM from '../updateDOM'
import once from 'utils/functional/once'
import initDOM from '../initDOM'
import saveToStorage from 'core/controllerPlans/saveToStorage'
import parseResponseToInitStore from 'core/controllerPlans/parse-response-to-init-store'

const recommendedParam = urlParameter('recommended')
const templateTile = getTemplate('template-tile')

function handleResponseFromEndpoints([responsePlans, recEngine]) {
  if (responsePlans.hasError) {
    renderError(responsePlans.description)
  } else {
    let showRecommend = false
    if (recEngine && !recEngine.error) {
      if (IS_AGENT) {
        if (recEngine.data && Object.keys(recEngine.data).length > 0) {
          recEngine = recEngine.data
          showRecommend = true
        }
      } else {
        showRecommend = !(recommendedParam && recommendedParam === 'no')
      }
    }

    const { hcStorage } = store.getState()
    const addonsByPlan = hcStorage.addonsByPlan || {}
    const addonsExternalByPlan = hcStorage.addonsExternalByPlan || {}

    store.setMiddleWare(applyRules)
    store.registry([once(initDOM), updateDOM, saveToStorage, appStateUpdated])
    store.update({
      ...parseResponseToInitStore({
        responseData: responsePlans
      }),
      sDate: hcStorage.sdate,
      recEngine,
      showRecommend,
      templateTile,
      addonsByPlan,
      addonsExternalByPlan
    })
  }

  return store
}

export default handleResponseFromEndpoints
